import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { Main } from '@components/Main';
import { PageContent } from '@components/PageContent';
import { PageTitle, PageTitleText } from '@components/PageTitle';
import { TableWrapper } from '@components/Table/TableWrapper';
import { useData } from '@hooks/useData';
import { useField } from '@hooks/useField';
import useLoading from '@hooks/useLoading';
import useMessage from '@hooks/useMessage';
import { useModalWindow } from '@hooks/useModalWindow';
import { FaturaDetalheModal } from '@mod/Fatura/FaturaDetalheModal';
import { ICaixaDescricaoFilter, ICaixaItemRecord, useCaixaService } from '@services/CaixaService';
import React from 'react';
import { CaixaDescricaoFilter } from './CaixaDescricaoFilter';
import { CaixaDescricaoTable } from './CaixaDescricaoTable';

export type CaixaDescricaoProps = {
}

export function CaixaDescricao (props: CaixaDescricaoProps) {
    const data = useData<ICaixaItemRecord, ICaixaDescricaoFilter>({
        filter: {
            descricao: useField(),
        },
    })

    const loading = useLoading();
    const message = useMessage();
    const caixaService = useCaixaService();
    const faturaDetalheModal = useModalWindow();

    React.useEffect(() => {
        if (!loading.isLoading) {
            data.filter.clearErrors();

            loading.start();
            caixaService.pesquisarDescricao(data.requestedData)
                .then(data.handleResultResponse)
                .catch(e => {
                    message.handleResponse(e)
                        .badRequest(data.filter.setErrorsFromServer)
                        .showException();
                })
                .finally(loading.stop);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data.requestedData]);

    return (
        <Main>
            <PageTitle>
                <HorizontalGrid>
                    <GridItem>
                        <PageTitleText text="Caixas - Pesquisar Descrição" />
                    </GridItem>
                </HorizontalGrid>
            </PageTitle>

            <PageContent>
                <CaixaDescricaoFilter
                    filter={data.filter}
                    isLoading={loading.isLoading}
                />
                
                <TableWrapper>
                    <CaixaDescricaoTable 
                        data={data}
                        isLoading={loading.isLoading}
                        faturaDetalheModal={faturaDetalheModal}
                    />
                </TableWrapper>
            </PageContent>

            {
                data.focusedRow && data.focusedRow.faturaId !== undefined && (
                    <FaturaDetalheModal 
                        faturaId={data.focusedRow.faturaId}
                        modal={faturaDetalheModal}
                    />
                )
            }
        </Main>
    )
}